import {XCircleIcon} from '@heroicons/react/solid'

function ErrorMessage(props: { numErrors: {} | null | undefined }) {
  if (props.numErrors == 1) {
    return (
      <h3 className="text-sm font-medium text-red-800">There was an error with your submission</h3>
    )
  }
  return (
    <h3 className="text-sm font-medium text-red-800">There were {props.numErrors} errors with your submission</h3>
  )
}

export default function ErrorAlert(props: any) {
  const messages = props.errors.filter((x: any) => x !== undefined);
  if (messages.length == 0) {
    return (<></>);
  }
  const errors = messages.map((error: any, index: number) => {
    return (
      <li key={index}>{error}</li>
    )
  });

  return (
    <div className="rounded-md mt-5 bg-red-50 p-4">
      <div className="flex">
        <div className="flex-shrink-0">
          <XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true"/>
        </div>
        <div className="ml-3">
          <ErrorMessage numErrors={errors.length}/>
          <div className="mt-2 text-sm text-red-700">
            <ul role="list" className="list-disc pl-5 space-y-1">
              {errors}
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}
